//设置胜平负颜色
export function checkColor(key) {
    let color = '';
    switch (key) {
        case '胜':
            color = '#ff0000'
            break;
        case '平':
            color = '#19f933'
            break;
        case '负':
            color = '#3bf2f9'
            break;
        default:
            color = 'black'
            break;
    }
    return color;
}

//盘口转换成数字
export function handicapToNum(str) {
    const handicapMap = {
      '平手': 0,
      '平/半': 0.25,
      '受平/半': -0.25,
      '*平/半': -0.25,
      '半球': 0.5,
      '受半球': -0.5,
      '*半球': -0.5,
      '半/一': 0.75,
      '受半/一': -0.75,
      '*半/一': -0.75,
      '一球': 1,
      '受一球': -1,
      '*一球': -1,
      '一/球半': 1.25,
      '受一/球半': -1.25,
      '*一/球半': -1.25,
      '球半': 1.5,
      '受球半': -1.5,
      '*球半': -1.5,
      '球半/两': 1.75,
      '受球半/两': 1.75,
      '*球半/两': -1.75,
      '两球': 2,
      '受两球': -2,
      '*两球': -2,
      '两/两球半': 2.25,
      '受两/两球半': -2.25,
      '*两/两球半': -2.25,
      '两球半': 2.5,
      '受两球半': -2.5,
      '*两球半': -2.5,
      '两球半/三': 2.75,
      '受两球半/三': -2.75,
      '*两球半/三': -2.75,
      '三球': 3,
      '受三球': -3,
      '*三球': -3,
      '三/三球半': 3.25,
      '受三/三球半': -3.25,
      '*三/三球半': -3.25,
      '三球半': 3.5,
      '受三球半': -3.5,
      '*三球半': -3.5,
      '三球半/四': 3.75,
      '受三球半/四': -3.75,
      '*三球半/四': -3.75,
      '四球': 4,
      '受四球': -4,
      '*四球': -4,
      '四/四球半': 4.25,
      '受四球/四球半': -4.25,
      '*四球/四球半': -4.25,
      '四球半': 4.5,
      '受四球半': -4.5,
      '*四球半': -4.5,
      '四球半/五': 4.75,
      '受四球半/五': -4.75,
      '*四球半/五': -4.75,
      '五球': 5,
      '受五球': -5,
      '*五球': -5,
      '五/五球半': 5.25,
      '受五球/五球半': -5.25,
      '*五球/五球半': -5.25,
      '五球半': 5.5,
      '受五球半': -5.5,
      '*五球半': -5.5,
      '五球半/六': 5.75,
      '受五球半/六': -5.75,
      '*五球半/六': -5.75,
      '六球': 6,
      '受六球': -6,
      '*六球': -6,
      '六/六球半': 6.25,
      '受六球/六球半': -6.25,
      '*六球/六球半': -6.25,
      '六球半': 6.5,
      '受七球半/七': -6.5,
      '*七球半/七': -6.5,
      '六球半/七': 6.75,
      '受六球半/七': -6.75,
      '*六球半/七': -6.75,
      '七球': 7,
      '受七球': -7,
      '*七球': -7,
    };
    return str === '' || undefined == str ? '--' : handicapMap[str];
}

//数字转换成盘口
export function numToHandicap(num) {
  let numStr = num.toString();
  let numMap = {
    '0': '平手',
    '0.25': '平/半',
    '-0.25': '*平/半',
    '0.5': '半球',
    '-0.5': '*半球',
    '0.75': '半/一',
    '-0.75': '*半/一',
    '-1': '*一球',
    '1': '一球',
    '1.25': '一/球半',
    '-1.25': '*一/球半',
    '1.5': '球半',
    '-1.5': '*球半',
    '1.75': '球半/两',
    '-1.75': '*球半/两',
    '2': '两球',
    '-2': '*两球',
    '2.25': '两/两球半',
    '-2.25': '*两/两球半',
    '2.5': '两球半',
    '-2.5': '*两球半',
    '2.75': '两球半/三',
    '-2.75': '*两球半/三',
    '3': '三球',
    '-3': '*三球',
    '3.25': '三/三球半',
    '-3.25': '*三/三球半',
    '3.5': '三球半',
    '-3.5': '*三球半',
    '3.75': '三球半/四',
    '-3.75': '*三球半/四',
    '4': '四球',
    '-4': '*四球',
    '4.25': '四/四球半',
    '-4.25': '*四/四球半',
    '4.5': '四球半',
    '-4.5': '四球半',
    '4.75': '四球半/五',
    '-4.75': '*四球半/五',
    '5': '五球',
    '-5': '*五球',
    '-5.25': '五/五球半',
    '5.25': '*五/五球半',
    '5.5': '五球半',
    '-5.5': '五球半',
    '5.75': '五球半/六',
    '-5.75': '*五球半/六',
    '6': '六球',
    '-6': '*六球',
    '-6.25': '六/六球半',
    '6.25': '*六/六球半',
    '6.5': '六球半',
    '-6.5': '六球半',
    '6.75': '六球半/七',
    '-6.75': '*六球半/七',
    '7': '七球',
    '-7': '*七球',
  }
  return numMap[numStr] || '无效值';
}

//qsda转换成实际数字盘口
export function convertToReal(number) {
    // console.log(number);
    const rules1 = [
      { min: 0, max: 25, result: [0.25] },//平/半
      { min: 26, max: 50, result: [0.5] },//半球
      { min: 51, max: 75, result: [0.75] },//半/一
      { min: 76, max: 100, result: [1] },//一球
      { min: 101, max: 125, result: [1.25] },//一球/球半
      { min: 126, max: 150, result: [1.5] },//球半
      { min: 151, max: 175, result: [1.75] },//球半/两球
      { min: 176, max: 200, result: [2] },//两球
      { min: 201, max: 225, result: [2.25] },//两球/两球半
      { min: 226, max: 250, result: [2.5] },//两球半
      { min: 251, max: 275, result: [2.75] },//两球半/三球
      { min: 276, max: 300, result: [3] },//三球
      { min: 301, max: 325, result: [3.25] },//三球/三球半
      { min: 326, max: 350, result: [3.5] },//三球半
      { min: 351, max: 375, result: [3.75] },//三球半/四球
      { min: 376, max: 400, result: [4] },//四球
      { min: 401, max: 425, result: [4.25] },//四球/四球半
      { min: 426, max: 450, result: [4.5] },//四球半
      { min: 451, max: 475, result: [4.75] },//四球半/五球
      { min: 476, max: 500, result: [5] },//五球
      { min: 501, max: 525, result: [5.25] },//五球/五球半
      { min: 526, max: 550, result: [5.5] },//五球半
      { min: 551, max: 575, result: [5.75] },//五球半/六球
      { min: 576, max: 600, result: [6] },//六球
      { min: 601, max: 625, result: [6.25] },//六球/六球半
      { min: 626, max: 650, result: [6.5] },//六球半
      { min: 651, max: 675, result: [6.75] },//六球半/七
      { min: 676, max: 700, result: [7] },//七球
    ];
    const rules2 = [
      { max: -1, min: -25, result: [0] },//平手
      { max: -26, min: -50, result: [-0.25] },//受平/半
      { max: -51, min: -75, result: [-0.5] },//受半球
      { max: -76, min: -100, result: [-0.75] },//受半/一
      { max: -101, min: -125, result: [-1] },//受一球
      { max: -126, min: -150, result: [-1.25] },//受一球/球半
      { max: -151, min: -175, result: [-1.5] },//受球半
      { max: -176, min: -200, result: [-1.75] },//受球半/两球
      { max: -201, min: -225, result: [-2] },//两球/两球半
      { max: -226, min: -250, result: [-2.25] },//两球半
      { max: -251, min: -275, result: [-2.5] },//两球半/三球
      { max: -276, min: -300, result: [-2.75] },//三球
      { max: -301, min: -325, result: [-3] },//三球/三球半
      { max: -326, min: -350, result: [-3.25] },//三球半
      { max: -351, min: -375, result: [-3.5] },//三球半/四球
      { max: -376, min: -400, result: [-3.75] },//四球
      { max: -401, min: -425, result: [-4] },//四球/四球半
      { max: -426, min: -450, result: [-4.25] },//四球半
      { max: -451, min: -475, result: [-4.5] },//四球半/五球
      { max: -476, min: -500, result: [-4.75] },//五球
      { max: -501, min: -525, result: [-5] },//五球/五球半
      { max: -526, min: -550, result: [-5.25] },//五球半
      { max: -551, min: -575, result: [-5.5] },//五球半/六球
      { max: -576, min: -600, result: [-5.75] },//六球
      { max: -601, min: -625, result: [-6] },//六球/六球半
      { max: -626, min: -650, result: [-6.25] },//六球半
      { max: -651, min: -675, result: [-6.5] },//六球半/七
      { max: -676, min: -700, result: [-6.75] },//七球
    ];
    
      let results;
    
      if (number >= 0) {
        // console.log('qsda > 0');
        for (const rule of rules1) {
          if (number >= rule.min && number <= rule.max) {
            results = rule.result;
          }
        }
      }
    
      if (number < 0) {
        // console.log('qsda < 0');
        for (const rule of rules2) {
        // console.log(number, '>=', rule.min,number >= rule.min, number, '<=', rule.max,number<= rule.max);
          if (number >= rule.min && number <= rule.max) {
            results = rule.result;
          }
        }
      }
    
    // console.log('result',results);
      if (results == null || typeof results == 'undefined') {
        // console.log('无');
        return 'undefind';
      }
      return results;
}

//大小球转换成数字
export function bsConvervToNum(bs){
  let bsNum = bs;
  let bsMap = {
    '1/1.5': 1.25,
    '1.5/2': 1.75,
    '2/2.5': 2.25,
    '2.5/3': 2.75,
    '3/3.5': 3.25,
    '3.5/4': 3.75,
    '4/4.5': 4.25,
    '4.5/5': 4.75,
    '5/5.5': 5.25,
    '5.5/6': 5.75
  }
  return bsMap[bsNum] || '无效值';
}

//篮球实际实力差换算
export function basketballZsVal(value){
  // 保留两位小数
  const roundedValue = Math.round(value * 100) / 100;
  const decimalPart = roundedValue % 1; // 获取小数部分

  if (decimalPart === 0) {
      return roundedValue; // 整数部分直接返回
  }

  if (roundedValue > 0) {
      // 对正数处理
      if (decimalPart <= 0.25) {
          return Math.floor(roundedValue); // 小数 <= 0.25 算 0
      } else if (decimalPart > 0.25 && decimalPart <= 0.75) {
          return Math.floor(roundedValue) + 0.5; // 小数 > 0.25 且 <= 0.75 算 0.5
      } else {
          return Math.ceil(roundedValue); // 小数 > 0.75 算 1
      }
  } else {
      // 对负数处理
      if (decimalPart >= -0.25) {
          return Math.ceil(roundedValue); // 小数 >= -0.25 算 0
      } else if (decimalPart < -0.25 && decimalPart >= -0.75) {
          return Math.ceil(roundedValue) - 0.5; // 小数 < -0.25 且 >= -0.75 算 -0.5
      } else {
          return Math.floor(roundedValue); // 小数 < -0.75 算 -1
      }
  }
}

//篮球大小球换算
export function bbBsVal(value){
    // 保留两位小数
    const roundedValue = Math.round(value * 100) / 100;
    const decimalPart = roundedValue % 1; // 获取小数部分

    if (decimalPart === 0) {
        return roundedValue; // 整数部分直接返回
    }

    if (roundedValue > 0) {
        // 对正数处理
        if (decimalPart <= 0.25) {
            return Math.floor(roundedValue); // 小数 <= 0.25 算 0
        } else if (decimalPart > 0.25 && decimalPart <= 0.5) {
            return Math.floor(roundedValue) + 0.5; // 小数 > 0.25 且 <= 0.75 算 0.5
        } else if (decimalPart > 0.5 && decimalPart <= 0.75) {
            return Math.floor(roundedValue) + 0.5; // 小数 > 0.25 且 <= 0.75 算 0.5
        } else if (decimalPart > 0.75 && decimalPart <= 1) {
            return Math.ceil(roundedValue); // 小数 > 0.25 且 <= 0.75 算 0.5
        }
    }
}

//足球大小球换算
export function fbBsVal(value){
  // 保留两位小数
  const roundedValue = Math.round(value * 100) / 100;
  const decimalPart = roundedValue % 1; // 获取小数部分

  if (decimalPart === 0) {
      return roundedValue; // 整数部分直接返回
  }

  if (roundedValue > 0) {
      // 对正数处理
      if (decimalPart <= 0.125) {
          // console.log('decimalPart < 0.125',roundedValue,decimalPart,Math.floor(roundedValue));
          return Math.floor(roundedValue); // 小数 <= 0.25 算 0
      } else if (decimalPart > 0.125 && decimalPart <= 0.25) {
          // console.log('decimalPart > 0.125 && decimalPart <= 0.25',roundedValue,decimalPart,Math.floor(roundedValue) + 0.25);
          return Math.floor(roundedValue) + 0.25; // 小数 > 0.125 且 <= 0.25 算 0.25
      } else if (decimalPart > 0.25 && decimalPart <= 0.625) {
          // console.log('decimalPart > 0.25 && decimalPart <= 0.625',roundedValue,decimalPart,Math.floor(roundedValue) + 0.5);
          return Math.floor(roundedValue) + 0.5; // 小数 > 0.25 且 <= 0.625 算 0.5
      } else if (decimalPart > 0.625 && decimalPart <= 0.875) {
          // console.log('decimalPart > 0.625 && decimalPart <= 0.875',roundedValue,decimalPart,Math.floor(roundedValue) + 0.75);
          return Math.floor(roundedValue) + 0.75; // 小数 > 0.625 且 <= 0.875 算 0.75
      } else if (decimalPart > 0.875 && decimalPart <= 1) {
          // console.log('decimalPart > 0.875 && decimalPart <= 1',roundedValue,decimalPart,Math.ceil(roundedValue));
          return Math.ceil(roundedValue); // 小数 > 0.875 且 <= 1 算 1
      }
  }
}

//篮球大小球颜色
export function footballBsColorSet(bigsmall,bs){
    let qsdaColor = 'rgb(128,0,255)';
    let bsNum = 0;
    if (bigsmall!=='') {
        if (bigsmall.includes('/')) {
            bsNum = bsConvervToNum(bigsmall);
        }else{
            bsNum = Number(bigsmall);
        }
        if (bs > bsNum) {
            // console.log('浅开',bs, '>', bsNum);
            qsdaColor = 'green';
            return qsdaColor
        }
        if (bs < bsNum) {
            // console.log('高开',bs, '<', bsNum);
            qsdaColor = 'red';
            return qsdaColor
        }
        if (bs === bsNum) {
            // console.log('实开',bs, '=', bsNum);
            qsdaColor = '#666';
            return qsdaColor
        }
    }else{
        return qsdaColor
    }
    
}

//判断高低开
export function compare(handicap, realHandicap) {
  if (handicap > 0 && handicap > realHandicap[0]) {
    // console.log(handicap,realHandicap[0],'高开');
    return 1;
  } else if (handicap > 0 && handicap < realHandicap[0]){
    // console.log(handicap,realHandicap[0],'浅开');
    return -1
  } else if (handicap < 0 && handicap > realHandicap[0]){
    // console.log(handicap,realHandicap[0],'浅开');
    return -1
  } else if (handicap < 0 && handicap < realHandicap[0]){
    // console.log(handicap,realHandicap[0],'高开');
    return 1
  } else if (handicap === 0 && realHandicap[0] > 0){
    // console.log(handicap,realHandicap[0],'高开');
    return 1
  } else if (handicap === 0 && realHandicap[0] < 0){
    // console.log(handicap,realHandicap[0],'浅开');
    return -1
  } else if (handicap === realHandicap[0]){
    // console.log(handicap,realHandicap[0],'实开');
    return 0
  }
    // if (Math.abs(handicap) === Math.abs(realHandicap)) {
    //     if (handicap < realHandicap) {
    //       // console.log(handicap, '<', realHandicap,'高开');
    //       return 1;
    //     } else if (handicap > realHandicap) {
    //       // console.log(handicap, '>', realHandicap,'高开');
    //       return 1;
    //     } else {
    //       // console.log(handicap, '=', realHandicap,'实开');
    //       return 0;
    //     }
    //   } else if (Math.abs(handicap) < Math.abs(realHandicap)) {
    //     // console.log(handicap, '<', realHandicap,'低开');
    //     // if (realHandicap < 0) {
    //     //     //应该客让，他是主让，对于让球方来说是高开
    //     //     console.log('高开');
    //     //     return 1;
    //     //   }
    //     return -1;
    //   } else if (Math.abs(handicap) > Math.abs(realHandicap)) {
    //     // console.log(handicap, '>', realHandicap,'高开');
    //     // if (handicap<0) {
    //     //     //应该客队让球，他反而主队让球，说明主队是强行让盘 0.5 > 0.25 -0.5 0.25 主让变客让
    //     //     console.log('低开');
    //     //     return -1;
    //     //   }
    //     return 1;
    //   }
}

//判断高低开是否通过
export function passState(hd, hs,as, state) {
  if(state=="低开"){
    if (hd >= 0) {
      if (hs-as > hd) {
        console.log('成功');
        return "W";
      }
      if(hs-as < hd){
        console.log('失败');
        return "L";
      }
    }else{
      if (hs-as > hd) {
        console.log('失败');
        return "L";
      }
      if(hs-as < hd){
        console.log('成功');
        return "W";
      }
    }
  }
  if (state=="高开") {
    if (hd >= 0) {
      if (hs-as > hd) {
        console.log('失败');
        return "W";
      }
      if(hs-as < hd){
        console.log('成功');
        return "L";
      }
    }else{
      if (hs-as > hd) {
        console.log('成功');
        return "W";
      }
      if(hs-as < hd){
        console.log('失败');
        return "D";
      }
    }
  }
  if (hs-as === hd) {
    console.log('走');
    return "-";
  }
  if (state === '实开') {
    console.log('忽略');
    return "-";
  }
}

//日期格式化
export function dateFormatted (date) {
  // const date = new Date();
  const year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();
  month = month < 9 ? '0'+( month + 1) : month + 1;
  day = day < 10 ? '0' + day : day;
  return year + '-' + month+'-' + day;
}

//球队排名简化纯数字
export function filteredNum(str){
  if (null == str || '' == str) {
    return '';
  }else{
    const rank = str.match(/\d+/) !==null ? '['+str.match(/\d+/)[0]+']' : '';
    return rank;
  }
}

//判断是否手机
export function isMobile() {
  const userAgent = navigator.userAgent;
  const isMobileDevice = /phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(userAgent);
  // 进一步判断 iPad
  const isTablet = /iPad|Macintosh/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isMobileDevice) {
    // console.log('移动端打开');
    return 'mobile';
  }else if(isTablet){
    console.log('平板打开');
    return 'tablet'
  }else {
      // console.log('PC端打开');
      return 'pc';
  }
}

//滚动到底部
export function scrollToBottom() {
  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
}

export function factorial(n) {
  if (n === 0 || n === 1) return 1;
  let result = 1;
  for (let i = 2; i <= n; i++) {
      result *= i;
  }
  return result;
}

//泊松分布概率计算
export function poissonDist(x, mean, cumulative = false) {
  if (cumulative) {
      // 计算累计概率
      let cumulativeProb = 0;
      for (let k = 0; k <= x; k++) {
          cumulativeProb += (Math.pow(mean, k) * Math.exp(-mean)) / factorial(k);
      }
      return cumulativeProb;
  } else {
      // 计算单点概率
      return (Math.pow(mean, x) * Math.exp(-mean)) / factorial(x);
  }
}

//进球概率
export function calculateScores(data) {
  let results = [];
  for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data.length; j++) {
        let value = Math.round((data[i].home * data[j].away * 10000))/10000;
        if (value > 0) {
            let key = `${i}-${j}`;
            results.push({ score: key, value: value,h: i, a: j });
            // console.log(key,value);
            
        }
      }
  }
  // 最高到低排序
  // results.sort((a, b) => b.value - a.value);
  // 仅保留最高的前三个值
  // results = results.slice(0, 3);
  return results;
}

///判断设备
export function checkDevice() {
  let ismobile = false;
    const userAgent = window.navigator.userAgent;
    const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
    ismobile = mobileAgents.some(agent => userAgent.includes(agent));
    // console.log('ooo',ismobile);
    return ismobile;
}

///篮球实力差计算
export function qsdaBbVal(value){
  // 保留两位小数
  const roundedValue = Math.round(value * 100) / 100;
  const decimalPart = roundedValue % 1; // 获取小数部分

  if (decimalPart === 0) {
      return roundedValue; // 整数部分直接返回
  }

  if (roundedValue > 0) {
      // 对正数处理
      if (decimalPart <= 0.25) {
          return Math.floor(roundedValue); // 小数 <= 0.25 算 0
      } else if (decimalPart > 0.25 && decimalPart <= 0.75) {
          return Math.floor(roundedValue) + 0.5; // 小数 > 0.25 且 <= 0.75 算 0.5
      } else {
          return Math.ceil(roundedValue); // 小数 > 0.75 算 1
      }
  } else {
      // 对负数处理
      if (decimalPart >= -0.25) {
          return Math.ceil(roundedValue); // 小数 >= -0.25 算 0
      } else if (decimalPart < -0.25 && decimalPart >= -0.75) {
          return Math.ceil(roundedValue) - 0.5; // 小数 < -0.25 且 >= -0.75 算 -0.5
      } else {
          return Math.floor(roundedValue); // 小数 < -0.75 算 -1
      }
  }
}

//篮球实力差颜色
export function basketballZsColorSet(handicap,qsda){
    // console.log('colorset',handicap,qsda);
    let txtcolor = '#8000ff';
    if (handicap == '') {
        txtcolor = '#8000ff'
    }else{
        if (Number(handicap) == basketballZsVal(qsda)) {
            txtcolor = 'black';
        }
        if (Number(handicap) >= 0) {
            if (Number(handicap) > basketballZsVal(qsda)) {
                txtcolor = 'red';
            }
            if (Number(handicap) < basketballZsVal(qsda)) {
                txtcolor = 'green';
            }
        }else{
            if (Number(handicap) < basketballZsVal(qsda)) {
                txtcolor = 'red';
            }
            if (Number(handicap) > basketballZsVal(qsda)) {
                txtcolor = 'green';
            }
        }
        
    }
    return txtcolor;
}

//篮球大小球颜色
export function basketballBsColorSet(bs,bsVal){
    let txtcolor = '#8000ff';
    if (bs == '') {
        txtcolor = '#8000ff'
    }else{
        if (Number(bs) == bbBsVal(bsVal)) {
            txtcolor = 'black';
        }
        if (Number(bs) > bbBsVal(bsVal)) {
            txtcolor = 'red';
        }
        if (Number(bs) < bbBsVal(bsVal)) {
            txtcolor = 'green';
        }
    }
    return txtcolor;
}

export function qsdaColorSet(handicap,qsda){
    let qsdaColor = 'rgb(128,0,255)';
    let lowOrHight = 2;
    if (handicap!=='') {
        const handicapNum = handicapToNum(handicap);
        const realHandicapNum = convertToReal(qsda);
        if (handicapNum === 0) {
            qsdaColor = 'rgb(128,0,255)';
            return qsdaColor
        }else{
            if (typeof handicapNum !== 'undefined' && typeof realHandicapNum !== 'undefined') {
                    lowOrHight = compare(handicapNum, realHandicapNum);
                if(lowOrHight === 0){
                    qsdaColor = this.isDark ? '#ccc' : 'black';
                    return qsdaColor
                }
                if (lowOrHight === 1) {
                    qsdaColor = 'red';
                    return qsdaColor
                }
                if (lowOrHight === -1) {
                    qsdaColor = 'green';
                    return qsdaColor
                }
            }
        }
    }
}

export function formattedDateToMMDD(date,time){
  const formattedDate = date.slice(5);
  if (time < '12:00') {
    const [month, day] = formattedDate.split('-').map(Number);
    // 获取当前年份
    const currentYear = new Date().getFullYear();
    // 创建一个新的 Date 对象，年份可以随意设置
    const d = new Date(currentYear, month - 1, day);
    // 日期加1天
    d.setDate(d.getDate() + 1);
    // 格式化新的日期
    const newMonth = String(d.getMonth() + 1).padStart(2, '0');
    const newDay = String(d.getDate()).padStart(2, '0');
    const newDateStr = `${newMonth}-${newDay}`;
    return newDateStr;
  }else{
    return formattedDate;
  }
}

export function qsdaVal(hxg,hfa,axg){
    if (hfa !== null || hfa !== undefined) {
      if (this.type === '足球') {
        if (this.isHFA) {
          return Math.round((hxg*(1+hfa)-axg) * 100)
        }
        return Math.round((hxg - axg) * 100)
      } else {
        const qsda = Math.round((hxg-axg) * 100)/100
        const res = basketballZsVal(qsda)
        // console.log('bbbbval...',res);
        return res;
      }
    }else{
      return Math.round((hxg-axg) * 100)
    }
}